<template>
  <div class="quick-order-product">
    <div class="row">
      <div class="col-xs-12 col-sm-3">
        <a :href="product.url" class="info" :title="product.title" v-html="product.name" />
      </div>
      <div class="clearfix visible-xs-block" />
      <quick-order-variant
        v-for="variant in product.variants"
        :key="variant.id"
        :variant="variant"
        :one-oz-limit="oneOzLimit"
        @change="onChange"
      />
    </div>
    <transition name="slide-fade">
      <div v-if="showOneOzWarning" class="row one-oz-warning text-center">
        All 1 oz fragrance oils are limited to {{ oneOzLimitAsWords }} per fragrance.
        Your quantity has been adjusted.
      </div>
    </transition>
  </div>
</template>

<script>
  import QuickOrderVariant from './variant'

  export default {
    components: {
      QuickOrderVariant
    },
    props: {
      product: {
        type: Object,
        required: true
      },
      oneOzLimit: {
        type: Number,
        default: null
      },
      oneOzLimitAsWords: {
        type: String,
        default: 'one bottle'
      }
    },
    data() {
      return {
        showOneOzWarning: false
      }
    },
    methods: {
      onChange(payload) {
        this.$emit('change', payload)
        if (payload.quantityAdjusted) {
          this.showOneOzWarning = true
        } else {
          this.showOneOzWarning = false
        }
      }
    }
  }
</script>

<style lang="scss">
  .quick-order-product {
    &:nth-child(even) .row {
      background-color: #fff;
    }

    &:nth-child(odd) .row {
      background-color: #f5f5f5;
    }

    .row {
      font-size: 90%;
      padding: 10px 0;
    }
  }
</style>
